import * as React from 'react';

import { Check } from '@freelancelabs/icons';
import { clsx } from '@freelancelabs/utils';

import { useCombinedRefs } from '../../../hooks';

export type CheckboxSize = 'small' | 'medium';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size' | 'value'> {
    /**
     * Interactions will be blocked while loading is true
     */
    loading?: boolean;
    label?: string;
    size?: CheckboxSize;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
    ({ id, label, className, title, loading, disabled, checked, children, size = 'medium', ...rest }, ref) => {
        const inputRef = React.useRef<HTMLInputElement>(null);
        const combinedRef = useCombinedRefs(inputRef, ref);

        return (
            <label
                htmlFor={id}
                className={clsx('checkbox-container', `checkbox-${size}`, disabled && 'checkbox-disabled', className)}
                title={title}
            >
                <input
                    ref={combinedRef}
                    disabled={disabled || loading}
                    id={id}
                    type="checkbox"
                    className="checkbox-input"
                    checked={checked}
                    {...rest}
                />
                <span className={clsx('checkbox-fakecheck', children || label ? 'spacer' : '')}>
                    <Check className="checkbox-fakecheck-img" size={size === 'small' ? 12 : 14} />
                </span>
                {label ? <span className="checkbox-label">{label}</span> : children}
            </label>
        );
    }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
